import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  inlineFilters: {
    padding: theme.spacing(3, 3, 0),
    backgroundColor: theme.palette.background.paper
  }
}));
